export const SLIDES = [
  {
    id: 1,
    title: "Grow Your Business With Innovative Ideas.",
    description:
      "We help businesses scale with modern technology, creative strategies, and tailored digital solutions that drive real results.",
    bannerImg:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/home3-banner-img.png",
  },
  {
    id: 2,
    title: "Transform Your Ideas Into Reality.",
    description:
      "From concept to execution, our team delivers innovative solutions that turn your vision into powerful digital products.",
    bannerImg:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/home3-banner-img3.png",
  },
  {
    id: 3,
    title: "Smart Solutions For Every Industry.",
    description:
      "Whether you’re a startup or enterprise, we provide scalable and reliable IT services customized to your business goals.",
    bannerImg:
      "https://appthing-website.s3.ap-south-1.amazonaws.com/home3-banner-img2.png",
  },
] as const;

export const PARTNERS = ["Zoho", "AWS Cloud", "MongoDB", "Render"] as const;

export const STAR_ICON =
  "https://appthing-website.s3.ap-south-1.amazonaws.com/star.svg";
